import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
    Box,
    // Button,
    Card,
    CardContent,
    TextField,
    makeStyles,
    IconButton,
    // Modal,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
} from '@material-ui/core'
import { X as CloseIcon } from 'react-feather'

const useStyles = makeStyles((theme) => ({
    root: {},
    importButton: {
        marginRight: theme.spacing(1)
    },
    exportButton: {
        marginRight: theme.spacing(1)
    },
    modal: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '100%',
        maxHeight: '80%',
        overflowY: 'auto'
    }
}))

const Toolbar = ({ className, filter, setFilter, ...rest }) => {
    const classes = useStyles()
    const [currentUid, setCurrentUid] = React.useState()

    // function handleChange(e) {
    //     setFilter(e.target.value)
    // }

    return (
        <div className={clsx(classes.root, className)} {...rest}>
            <Box mt={0}>
                <Card>
                    <CardContent>
                        <Box
                            flexDirection="row"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Box
                                flexDirection="row"
                                display="flex"
                                alignItems="center"
                            >
                                <FormControl
                                    variant="outlined"
                                    // fullWidth
                                    style={{
                                        maxWidth: 140,
                                        marginRight: 10
                                    }}
                                >
                                    <InputLabel id="demo-simple-select-label">
                                        Search By
                                    </InputLabel>
                                    <Select
                                        style={{ minWidth: 100 }}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Search By"
                                        value={'uid'}
                                    >
                                        <MenuItem value="uid">UID</MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField
                                    // fullWidth
                                    style={{
                                        width: 400,
                                        marginRight: 10
                                    }}
                                    value={filter}
                                    id="search-keywords"
                                    variant="outlined"
                                    placeholder="Enter your keywords"
                                    onChange={(e) => {
                                        setCurrentUid(e.target.value)
                                    }}
                                />
                                <Button
                                    disabled={currentUid === filter}
                                    onClick={() => setFilter(currentUid)}
                                    variant="contained"
                                    size="large"
                                    color="primary"
                                    className={classes.margin}
                                >
                                    Search
                                </Button>
                            </Box>

                            {filter ? (
                                <IconButton
                                    onClick={() => {
                                        setFilter(null)
                                        document.getElementById(
                                            'search-keywords'
                                        ).value = ''
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            ) : null}
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    )
}

Toolbar.propTypes = {
    className: PropTypes.string,
    filter: PropTypes.string,
    setFilter: PropTypes.func
}

export default Toolbar
